/**
 * The look every data table shares: CommonTable and the tables dashboard panels draw by hand.
 * Change a value here and both follow.
 */

/** Side padding of a header or body cell. */
export const TABLE_CELL_PADDING_CLASS = 'px-6'

/** Height, text size, weight and colour of a header cell. */
export const TABLE_HEADER_CELL_CLASS = 'table-header-control text-control text-foreground'

function cssPixels(variable: string, fallback: number): number {
	if (typeof document === 'undefined') {
		return fallback
	}
	const value = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue(variable))
	return Number.isFinite(value) && value > 0 ? value : fallback
}

/** The body row height from `--height-table-row`, for code that positions or counts rows in pixels. */
export const tableRowHeightPx = () => cssPixels('--height-table-row', 32)

/** The header row height from `--height-table-header`. */
export const tableHeaderHeightPx = () => cssPixels('--height-table-header', 36)
